const defaultLanguage = 'en-US'

const isTest = process.env.NODE_ENV === 'test'

function initialState() {
  return {
    resources: !isTest
      ? { loadingLanguage: true }
      : require(`./resources/${defaultLanguage}.json`),
    languages: require('./resources/languages.json'),
    languageSelected: defaultLanguage,
  }
}

// initial state
const state = initialState()

// getters
const getters = {
  resources: state => state.resources,
  languages: state => state.languages,
  languageSelected: state => state.languageSelected,
  loadingLanguage: state => state.resources.loadingLanguage,
  recommendationPost: state =>
    state.resources.loadingLanguage
      ? {}
      : state.resources.page.reports.engagement.recommendation.post,

  taskList: state =>
    state.resources.loadingLanguage ? {} : state.resources.component.taskList,
  taskInput: state =>
    state.resources.loadingLanguage
      ? {}
      : state.resources.component.taskList.taskInput,
  circleChart: state =>
    state.resources.loadingLanguage
      ? {}
      : state.resources.component.circleChart,
}

// actions
const actions = {
  setLanguage({ state, commit }, language = window.localStorage.languageabrev) {
    const codes = state.languages.map(i => i.code)
    const hasLanguage = language => codes.includes(language) && language
    const navigatorIdiom = () =>
      codes.find(i => i.includes(navigator.language.slice(0, 2)))

    commit(
      'setLanguage',
      hasLanguage(language) ||
        hasLanguage(navigator.language) ||
        navigatorIdiom() ||
        defaultLanguage
    )
  },
}

// mutations
const mutations = {
  setLanguage(state, language) {
    state.resources = require(`./resources/${language}.json`)
    state.languageSelected = language
    window.localStorage.languageabrev = language
  },
  setLoadingLanguage(state, loadingLanguage) {
    state.resources.loadingLanguage = loadingLanguage
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
